
import { useState } from "react";
import { getProjects } from "../../api/projectApi";

export default function useProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0); // optional but useful

  const fetchProjects = async (options = {}) => {
    try {
      setLoading(true);

      const params = {
        pagination: options.pagination ?? undefined, // only send if provided
        ...options
      };

      const data = await getProjects(params);

      // Handle both paginated and non-paginated responses
      const projectList = data.results || data || [];

      setProjects(projectList);
      setTotalCount(data.count || projectList.length);

      return {
        success: true,
        data: projectList,
        total: data.count || projectList.length,
      };
    } catch (error) {
      console.error("Failed to fetch projects:", error);
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return {
    projects,
    loading,
    totalCount,
    fetchProjects,
  };
}